export async function downloadFromSignedUrl(signedUrl) {
    try {
        const response = await fetch(signedUrl);
        if (!response.ok) throw new Error("Download failed");

        const blob = await response.blob();

        // Extract filename
        let fileName = "download-file";
        const cd = response.headers.get("Content-Disposition");

        if (cd && cd.includes("filename=")) {
            fileName = cd.split("filename=")[1].replace(/"/g, "");
        } else {
            const pathname = new URL(signedUrl).pathname;
            fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
        }

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);

        return true;
    } catch (err) {
        console.error("Download error:", err);
        return false;
    }
}
